import { CssBaseline } from '@mui/material';
import { NotificationsProvider, PageNotFound } from '@vestwell-frontend/ui';

import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { GiftingRedirect, NavbarLayout } from './components';
import { routes } from './routes';

const GiftingDashboardPage = lazy(() => import('./pages/GiftingDashboardPage'));
const GiftingAccountDashboardPage = lazy(
  () => import('./pages/account/GiftingAccountDashboardPage')
);
const GiftingPublicLandingPage = lazy(
  () => import('./pages/GiftingPublicLandingPage')
);
const GiftingStartPage = lazy(() => import('./pages/GiftingStartPage'));
const GiftingLoggedInStartPage = lazy(
  () => import('./pages/account/GiftingLoggedInStartPage')
);
const GiftingOccasionPage = lazy(() => import('./pages/GiftingOccasionPage'));
const GiftingInfoPage = lazy(() => import('./pages/GiftingPublicInfoPage'));
const GiftingBankPage = lazy(() => import('./pages/GiftingBankPage'));
const GiftingReviewPage = lazy(() => import('./pages/GiftingReviewPage'));
const GiftingSuccessPage = lazy(() => import('./pages/GiftingSuccessPage'));
const GiftingPasswordPage = lazy(() => import('./pages/GiftingPasswordPage'));
const GiftingAccountRecipientContainerPage = lazy(
  () => import('./pages/account/GiftingAccountRecipientContainerPage')
);
const GiftingMaintenancePage = lazy(
  () => import('./pages/GiftingMaintenancePage')
);

export const AppRouter = () => {
  return (
    <>
      <CssBaseline />
      <NotificationsProvider>
        <NavbarLayout>
          <Routes>
            <Route
              element={<GiftingMaintenancePage />}
              path={routes.GiftingMaintenancePage}
            />
            <Route
              element={<GiftingAccountDashboardPage />}
              path={routes.GiftingAccountDashboard}>
              <Route
                element={<GiftingAccountRecipientContainerPage />}
                path={routes.GiftingAccountRecipientContainer}>
                <Route
                  element={<GiftingLoggedInStartPage />}
                  path={routes.GiftingAccountRecipientStartPage}
                />
                <Route
                  element={<GiftingOccasionPage />}
                  path={routes.GiftingAccountRecipientOccasionPage}
                />
                <Route
                  element={<GiftingBankPage />}
                  path={routes.GiftingAccountRecipientBankPage}
                />
                <Route
                  element={<GiftingReviewPage />}
                  path={routes.GiftingAccountRecipientReviewPage}
                />
                <Route
                  element={<GiftingSuccessPage />}
                  path={routes.GiftingAccountRecipientSuccessPage}
                />
              </Route>
            </Route>
            <Route
              element={<GiftingDashboardPage />}
              path={routes.GiftingDashboard}
            />
            <Route
              element={<GiftingPublicLandingPage />}
              path={routes.GiftingPublicLanding}>
              <Route
                element={<GiftingStartPage />}
                path={routes.GiftingPublicStartPage}
              />
              <Route
                element={<GiftingOccasionPage />}
                path={routes.GiftingPublicOccasionPage}
              />
              <Route
                element={<GiftingInfoPage />}
                path={routes.GiftingPublicInfoPage}
              />
              <Route
                element={<GiftingPasswordPage />}
                path={routes.GiftingPasswordPage}
              />
              <Route
                element={<GiftingBankPage />}
                path={routes.GiftingPublicBankPage}
              />
              <Route
                element={<GiftingReviewPage />}
                path={routes.GiftingReviewPage}
              />
              <Route
                element={<GiftingSuccessPage />}
                path={routes.GiftingSuccessPage}
              />
            </Route>
            <Route
              element={<GiftingRedirect />}
              path={routes.GiftingRedirect}
            />
            <Route
              element={
                <PageNotFound
                  basePath='/gifting'
                  defaultPath={routes.GiftingDashboard}
                />
              }
              path='*'
            />
          </Routes>
        </NavbarLayout>
      </NotificationsProvider>
    </>
  );
};
